/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useEffect } from "react";
import {
	ButtonLayout,
	ButtonPrimary,
	Grid,
	IconWarningLight,
	Text3,
	skinVars,
	useScreenSize,
} from "@telefonica/mistica";

import { observer } from "mobx-react-lite";
import { useAnalytics, useNavigateCustom } from "../../../../hooks";
import { strings } from "../../../../localization";
import { ScreenResponsive } from "../../../../components/organisms";
import { FeedbackContainer } from "../../../../components";

const { button, description, title } = strings.pages.errorOldDocument;

const ErrorOldDocument: React.FC = observer(() => {
	const navigation = useNavigateCustom();
	const { isDesktopOrBigger } = useScreenSize();
	const { addAnalyticEvent, updatePageView } = useAnalytics();

	useEffect(() => {
		updatePageView({ name: "Vivo Pay FGTS documento com mais de 10 anos", pagePath: "/fgts/error_old_document" });
	}, []);

	// Função que redireciona o usuário para a tela de reenvio de documento
	const onResendDocument = () => {
		navigation("/fraud-analysis", { replace: true, state: { resendDocument: true } });
		addAnalyticEvent({ action: "click.button", step: "fgts:resend-document", description: button }, { applySanitize: true});
	};

	const handlePopState = (): void => {
		navigation("/fraud-analysis", { replace: true });
	};

	useEffect(() => {

		// Adiciona um listener ao evento popstate
		window.addEventListener("popstate", handlePopState);

		// Limpa o listener ao desmontar o componente
		return () => {
			window.removeEventListener("popstate", handlePopState);
		};
	}, [navigation]);

	return (
		<ScreenResponsive>
			<Grid justifyContent="center">
				<FeedbackContainer
					icon={<IconWarningLight size={64} color={skinVars.colors.brand} />}
					title={title}
					description={description}
				>
					<ButtonLayout align={isDesktopOrBigger ? "left" : "center"}>
						<ButtonPrimary onPress={onResendDocument} style={{ width: isDesktopOrBigger ? "auto" : "100%" }}>
							<Text3 medium color={skinVars.colors.textButtonPrimary}>
								{button}
							</Text3>
						</ButtonPrimary>
					</ButtonLayout>
				</FeedbackContainer>
			</Grid>
		</ScreenResponsive>
	);
});

export default ErrorOldDocument;
